import { atom } from 'jotai';

export const activeTableSitesAtom = atom([]);